import { LocationSelect } from 'browser/components/atomic-elements/atoms/select/location-select/location-select'
import LabelFieldFactory from 'browser/components/atomic-elements/higher-order-components/label-field-factory'
const LocationSelectField = LabelFieldFactory({ InputComponent: LocationSelect })
export {LocationSelectField}
